import Vue from 'vue'
import VueRouter from 'vue-router'
import index from './page/index.vue'
import results from './page/Results.vue'
import detail from './page/detail.vue'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [{
        // 重定向首页路由
        path: '/',
        redirect: "/index",
        component: index,
        meta: {
            title: '笔试题型查询'
        },
    },
    {
        path: '/index',
        name: "index",

        component: index
    },
    {
        path: '/results',
        name: "results",
        component: results
    }, {
        path: '/detail',
        name: "detail",
        component: detail
    },
]

const router = new VueRouter({
    // mode: 'history',
    routes: routes
})

export default router;